<template>
  <el-popover placement="bottom" width="300" v-model="visible">
    <section>
      <el-table
        v-loading="tableData.loading"
        ref="multipleTable"
        :data="tableData.data"
        tooltip-effect="dark"
        height="300"
        @select="handleSelectionChange"
        @select-all="handleSelectionChange"
      >
        <!-- 选择框 -->
        <el-table-column type="selection" width="30" />
        <!-- 操作按钮 -->
        <el-table-column fixed="right" label="操作" align="center" width="150">
          <template slot-scope="scope">
            <section class="table-setting-ctrl-box">
              <el-switch
                active-text="固定"
                v-model="tableData.data[scope.$index].fixed"
                @change="
                  handleChangeFixed(
                    tableData.data[scope.$index].fixed,
                    scope.$index
                  )
                "
              />
              <section class="ctrl-updown-box">
                <i
                  class="iconfont primary cur"
                  @click="goUp(scope.$index)"
                  v-if="scope.$index"
                  >&#xe603;</i
                >
                <i
                  class="iconfont primary cur"
                  @click="goDown(scope.$index)"
                  v-if="scope.$index !== tableData.data.length - 1"
                  >&#xe604;</i
                >
              </section>
            </section>
          </template>
        </el-table-column>
        <!-- 操作按钮 end -->
        <!-- 常规列表项 -->
        <el-table-column
          v-for="(item, index, key) in tableData.title"
          :key="key"
          :prop="item.prop"
          :label="item.label"
          :type="item.type || null"
          :sortable="item.sortable"
          :filters="item.filters"
          :filter-method="item.filterHandler"
          :min-width="item.minW"
          :width="120"
          :fixed="item.fixed"
          align="center"
        >
        </el-table-column>
      </el-table>
      <section class="table-setting-btn-box">
        <!-- <el-button
          class="table-setting-btn"
          type="info"
          size="mini"
          @click="visible = !visible"
          >关闭</el-button
        > -->
        <el-button
          class="table-setting-btn"
          type="primary"
          size="mini"
          @click="resetToRawData"
          >重置</el-button
        >
      </section>
    </section>
    <el-button
      type="primary"
      plain
      slot="reference"
      @click="showSettings"
      :disabled="!!!tableData.data.length"
    >
      表格设置
    </el-button>
  </el-popover>
</template>

<script>
import tableMixin from '@qx/mixin/table';
export default {
  mixins: [
    tableMixin,
  ],
  model: {
    prop: 'resultVal', // 父级传进来的值
    event: 'change',
  },
  props: {
    resultVal: {
      type: Array,
      default: () => ([]),
    },
    // 显示隐藏的属性名
    showAttrName: {
      type: String,
      default: 'show',
    },
  },
  watch: {
    resultVal: {
      immediate: true,
      deep: true,
      handler (newValue) {
        if (newValue && newValue.length) {
          // 如果宽度有改变，则更新本地缓存的 minW 字段
          const currentLocalData = this.getLocalData();
          this.addDataOtherProp(newValue, currentLocalData);
          this.setLocalData(currentLocalData);
          // 原始数据备份，则更新本地缓存的 minW 字段
          const currentRawData = this.getRawData();
          this.addDataOtherProp(newValue, currentRawData, false);
          this.backupRawData(currentRawData);
        }
      },
    },
  },
  computed: {
  },
  data () {
    return {
      visible: false,
      userInfo: JSON.parse(localStorage.getItem('USERINFO') || '{}').staffTFInfo || {},
      tableData: { // 表格相关数据
        selectTar: 'prop',
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          { prop: 'label', label: '表头名称' },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    // 点击设置表格按钮
    showSettings () {
      if (this.tableData.data.length) {
        this.toggleSelection(this.tableData.data);
      }
    },
    // 通过修改 show 属性来控制表头的显示和隐藏
    handleSelectionChange (currentSelection) {
      const newTableList = this.tableData.data.map((item) => {
        item[this.showAttrName] = currentSelection.some((info) => info.prop === item.prop);
        return item;
      });
      this.setLocalData(newTableList);
      this.setOutsideData(newTableList);
    },
    // 设置是否固定表头
    handleChangeFixed (isSelected, index) {
      if (this.tableData.data.filter((d) => d.fixed === true).length > 5) {
        this.tableData.data[index].fixed = false;
        this.$message.warning('最多只能选择五列固定列！');
        return;
      }
      this.tableData.data[index].fixed = isSelected;
      const elem = this.tableData.data[index];
      // 将 fixed 为 true 的摆在最前面
      const fixedList = [];
      for (let i = this.tableData.data.length - 1; i >= 0; i--) {
        if (this.tableData.data[i].fixed) {
          fixedList.unshift(this.tableData.data[i]);
          this.tableData.data.splice(i, 1);
        }
      }
      this.tableData.data.unshift(...fixedList);

      // // 找出最后一个 fixed 为 true 的位置插入
      // if (elem.fixed) {
      //   const insertEle = this.tableData.data.splice(index, 1);
      //   let inserIndex = 0;
      //   this.tableData.data.forEach((item) => {
      //     if (item.fixed) {
      //       inserIndex++;
      //     }
      //   });
      //   this.tableData.data.splice(inserIndex, 0, ...insertEle);
      // }

      if (!elem.fixed) {
        // 获取初次加载时保存的原始数据
        let orignalData = this.getRawData();
        let fixedData = [];
        let newData = [];
        this.tableData.data.forEach((item1, index1) => {
          if (item1.fixed) {
            fixedData.push(item1);
          }
        });
        orignalData.forEach((item, index) => {
          this.tableData.data.forEach((item1, index1) => {
            if (!item1.fixed && item.prop === item1.prop) {
              newData.push(item1);
            }
          });
        });

        this.tableData.data = [...fixedData, ...newData];
        setTimeout(() => {
          this.toggleSelection(this.tableData.data);
        }, 100);

      }

      this.setLocalData(this.tableData.data);
      this.setOutsideData(this.tableData.data);
    },
    // 添加数据的其他属性
    addDataOtherProp (newValue, currentData, isChangeProp = true) {
      for (let item of newValue) {
        if (currentData && currentData.length) {
          for (let info of currentData) {
            if (item.prop === info.prop) {
              for (let attr in item) {
                if (isChangeProp) {
                  if (item[attr]) {
                    // 当前数据随时更新
                    info[attr] = item[attr];
                  }
                } else {
                  // 备份原始数据，除了宽度之外，其他属性都不需要更新
                  if (info[attr] === undefined) {
                    info[attr] = item[attr];
                  }
                  if (info.minW !== item.minW) {
                    info.minW = item.minW;
                  }
                }
              }
            }
          }
        }
      }
    },
    // 设置数据的默认属性
    setDataDefaultProp (data) {
      if (data && Array.isArray(data)) {
        data.map((item) => {
          // 如果没有设置固定值，则默认不固定
          if (!item.hasOwnProperty('fixed')) {
            item.fixed = false;
          }
          // 如果没有设置显示隐藏属性，则默认显示
          if (!item.hasOwnProperty(this.showAttrName)) {
            item[this.showAttrName] = true;
          }
          // 如果没有设置 prop 属性，则使用 label 值代替
          if (!item.hasOwnProperty('prop')) {
            item.prop = item.label;
          }
        });
      }
    },
    // 根据 userid 和 地址 作为索引获取本地表格设置数据
    getLocalData (dataName = 'tableSetting', saveType = 'localStorage') {
      let userDataStr = null;
      if (saveType === 'localStorage') {
        userDataStr = localStorage.getItem(this.userInfo.userId);
      } else {
        userDataStr = sessionStorage.getItem(this.userInfo.userId);
      }
      let tableData = null;
      if (userDataStr) {
        // 已有数据
        const userData = JSON.parse(userDataStr);
        tableData = userData[dataName][`${this.$route.name}`];
      }
      return tableData;
    },
    // 根据 userid 和 地址 作为索引设置本地表格设置数据
    setLocalData (data, dataName = 'tableSetting', saveType = 'localStorage') {
      let userDataStr = null;
      let userData = null;
      if (saveType === 'localStorage') {
        userDataStr = localStorage.getItem(this.userInfo.userId);
      } else {
        userDataStr = sessionStorage.getItem(this.userInfo.userId);
      }
      if (userDataStr) {
        // 已有数据
        userData = JSON.parse(userDataStr);
      } else {
        // 没有数据
        userData = {
          [`${dataName}`]: {},
        };
      }
      if (userData) {
        userData[dataName][`${this.$route.name}`] = data;
        if (saveType === 'localStorage') {
          localStorage.setItem(`${this.userInfo.userId}`, JSON.stringify(userData));
        } else {
          sessionStorage.setItem(`${this.userInfo.userId}`, JSON.stringify(userData));
        }
      }
    },
    // 清除本地缓存
    removeLocalData () {
      // localStorage.removeItem(`tableSetting-${this.$route.name}-${this.userInfo.userId}`);

      const userDataStr = localStorage.getItem(this.userInfo.userId);
      if (userDataStr) {
        // 已有数据
        const userData = JSON.parse(userDataStr);
        delete userData[this.$route.name];
        localStorage.setItem(`${this.userInfo.userId}`, JSON.stringify(userData));
      }
    },
    // 备份原始数据
    backupRawData (data) {
      this.setDataDefaultProp(data);
      this.setLocalData(data, 'rawDataTableSetting', 'sessionStorage');
    },
    // 获取原始数据
    getRawData () {
      return this.getLocalData('rawDataTableSetting', 'sessionStorage');
    },
    // 重置成原始数据
    resetToRawData () {
      // 清空本地缓存
      this.removeLocalData();
      // 获取初次加载时保存的原始数据
      this.tableData.data = this.getRawData();
      // 将原始数据保存在本地
      this.setLocalData(this.tableData.data);
      // 同步原始数据到外部
      this.setOutsideData(this.tableData.data);
      // 设置选中和固定状态
      setTimeout(() => {
        this.showSettings();
      }, 100);
    },
    // 设置外部数据
    setOutsideData (data) {
      // // 清除掉隐藏的表头
      // for (let i = data.length - 1; i >= 0; i--) {
      //   if (!data[i][this.showAttrName]) {
      //     data.splice(i, 1);
      //   }
      // }
      this.$emit('change', data);
    },
    // 设置选中状态（注：因为 mounted 生命周期里设置会失效，所以改为点击按钮之后再设置）
    toggleSelection (arr) {
      if (arr) {
        arr.forEach((item) => {
          this.$refs.multipleTable.toggleRowSelection(item, item[this.showAttrName]);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    // 往上
    goUp (index) {
      this.swapArr(this.tableData.data, index, index - 1);
    },
    // 往下
    goDown (index) {
      this.swapArr(this.tableData.data, index, index + 1);
    },
    // 数组元素位置更换
    swapArr (arr, currentIndex, targetIndex) {
      arr[currentIndex] = arr.splice(targetIndex, 1, arr[currentIndex])[0];
      this.setLocalData(arr);
      this.setOutsideData(arr);
      return arr;
    },
    // 初始化本地数据
    initLocalData () {
      if (this.getLocalData()) {

        /**
         * 如果最新的源码数据和本地缓存数据对比有变化，则重置成当前源码的数据
         * 如果数据没有变化，则使用本地缓存
         */
        const localData = this.getLocalData();
        if (localData.length === this.resultVal.length) {
          const isDataChange = !(this.resultVal.every((item) => localData.some((info) => item.prop === info.prop && item.label === info.label)));
          if (isDataChange) {
            this.removeLocalData();
            this.updateLocalData();
          } else {
            this.tableData.data = localData;
            this.setOutsideData(this.tableData.data);
          }
        } else {
          this.removeLocalData();
          this.updateLocalData();
        }
      } else {
        this.removeLocalData();
        this.updateLocalData();
      }
    },
    // 更新本地缓存
    updateLocalData () {
      // 如果没有本地缓存，将传进来的默认数据设置到本地
      this.setDataDefaultProp(this.resultVal);
      this.tableData.data = this.resultVal;
      this.setLocalData(this.resultVal);
      this.setOutsideData(this.resultVal);
    },
  },
  mounted () {
    this.initLocalData();
    this.backupRawData(this.resultVal);
  },
};
</script>

<style scoped lang="scss">
.table-list-box {
  padding: 10px;
}
.table-setting-btn-box {
  text-align: center;
  margin-top: 10px;
}
.table-setting-ctrl-box {
  display: flex;
  .ctrl-updown-box {
    width: 38px;
    margin-left: 10px;
    text-align: center;
    .iconfont {
      &:first-child {
        margin-left: 0;
      }
      margin-left: 6px;
    }
  }
}
</style>
